export default "__VITE_ASSET__lqsvU0K8__"